export default () => ({
  application: null,
})
